import { buildBadgeHtml, buildIconHtml, buildPostHtml } from './timeline-service';

/**
 * Handles updating the component when new data is received
 *
 * @param  {Object} existingEvents Events already on the DOM
 * @param  {Object} polledData Response from polling
 */
function removeDomEventsNotInPollResponse(existingEvents, polledData) {
  const polledIds = polledData.items.map(event => `sdc-site-match-timeline-${event.feedTimestamp}`);
  const eventsNotInPolledData = [...existingEvents].filter(event => !polledIds.includes(event.id));

  eventsNotInPolledData.forEach(event => event.remove());
}

/**
 * Handles updating the component when new data is received
 *
 * @param  {htmlNode} rootElement The component root node
 * @param  {Object} config The component configuration
 * @param  {Object} data The new data to update the component with
 */
export default function(rootElement, config, data) {
  if (!rootElement || !config || !data) {
    return;
  }

  const polledData = data;
  const timelineSelector = 'sdc-site-match-timeline';
  const existingEvents = rootElement.getElementsByClassName(`${timelineSelector}__post`);
  const newEvents = document.createDocumentFragment();

  if (polledData !== null && polledData.items) {
    polledData.items.forEach(polledEvent => {
      const polledId = `${timelineSelector}-${polledEvent.feedTimestamp}`;

      if ([...existingEvents].some(event => polledId === event.id)) {
        return;
      }

      if (polledEvent.badge) {
        polledEvent.badge = buildBadgeHtml({
          polledEvent,
          config
        });
      }

      if (polledEvent.iconName) {
        polledEvent.iconHtml = buildIconHtml({
          polledData,
          polledEvent,
          config
        });
      }

      const postElement = buildPostHtml({
        polledEvent,
        config
      });

      if (postElement.innerHTML !== '') {
        newEvents.appendChild(postElement);
      }
    });
  }

  rootElement.insertBefore(newEvents, rootElement.firstChild);

  removeDomEventsNotInPollResponse(existingEvents, polledData);
}
